const PaymentCDActionTypes = {
  SET_PAYMENT_CONFIRM_LIST: 'SET_PAYMENT_CONFIRM_LIST',
  SET_PAYMENT_AMOUNT: 'SET_PAYMENT_AMOUNT',
  SET_PAYMENT_CD_LIST: 'SET_PAYMENT_CD_LIST',
  SET_EDIT_PAYMENT_INFO: 'SET_EDIT_PAYMENT_INFO',
  SET_EDIT_PAYMENT_INDEX: 'SET_EDIT_PAYMENT_INDEX',
  EDIT_PAYMENT_CD_LIST: 'EDIT_PAYMENT_CD_LIST',
  DELETE_PAYMENT_CONFIRM_LIST: 'DELETE_PAYMENT_CONFIRM_LIST',
  CLEAR_PAYMENT_CONFIRM_LIST: 'CLEAR_PAYMENT_CONFIRM_LIST',
  SET_SELECTED_CIF_ID: 'SET_SELECTED_CIF_ID',
  SET_DEFAULT_STATE: 'SET_DEFAULT_STATE'
};

export default PaymentCDActionTypes;
